import React from 'react';
import {
    Box,
    IconButton,
    BottomNavigationAction,
    BottomNavigationActionProps,
    createStyles,
    makeStyles,
    Theme,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import cx from 'classnames';

type Props = {
    link?: string;
    active?: boolean;
} & Pick<BottomNavigationActionProps, 'icon' | 'label'>;

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            [theme.breakpoints.down('xs')]: {
                padding: 0,
                minWidth: 0,
            },
        },
        icon: {
            color: `${theme.palette.primary.main}`,
        },
    }),
);

const TopBarNavIcon: React.FC<Props> = ({ icon, label, link, active }) => {
    const classes = useStyles();
    return (
        <Box position="relative" display="flex" height="100%">
            <IconButton component={Link} to={link} size="small">
                <BottomNavigationAction
                    // className={active && classes.icon}
                    className={cx(classes.root, { [classes.icon]: active })}
                    showLabel
                    icon={icon}
                    label={label}
                />
            </IconButton>
            {/* {active && (
                <Box
                    mt={1}
                    bottom={-10}
                    right={-6}
                    left={-10}
                    position="absolute"
                    height={3}
                    bgcolor="primary.main"
                    borderRadius={30}
                />
            )} */}
        </Box>
    );
};

export default TopBarNavIcon;
